import "./testimonials.css";
import { useTranslation } from "react-i18next";

const testimonials = [
  {
    name: "Sandeep",
    designation: "Director, EpicsAI",
    text: "We are delighted to use the workflow application developed by the Sigvion team. It has streamlined our operations and allowed us to adapt processes that suit us best. The team’s professionalism and support were exceptional. We highly recommend Sigvion for their top-notch software solutions and seamless delivery.",
  },
  {
    name: "Karthik",
    designation: "MEC Industries",
    text: "We are extremely pleased with Sigvion’s partnership in IT and process consulting for the automotive and manufacturing industry. Their commitment to timely delivery, innovation, and quality work has been remarkable. Sigvion’s expertise and collaboration have added immense value to our operations and success.",
  },
  {
    name: "Claus Steininger",
    designation: "Director, Koncepthouse",
    text: "We are thrilled with Sigvion and their transformative IT solutions. After integration, our efficiency improved drastically and manual tasks reduced significantly. The team’s dedication, support, and tailored approach were outstanding. We highly recommend Sigvion to any business seeking reliable digital transformation.",
  },
];


export default function Testimonials() {
  const { t } = useTranslation();
  return (
    <div className="testimonials-section-container">
      <p className="testimonials-main-title">{t("Testimonials")}</p>
      <h2 className="testimonials-title">{t("What Our Customers Say")}</h2>
      <p className="testimonials-desc">{t("Discover how our clients have transformed their businesses with our innovative IT solutions and dedicated support.")}</p>
      <div className="testimonials-container">
        {testimonials.map((d, i) => (
          <div key={i} className="testimonial-card">
            <div>
                <i className="fa-solid fa-quote-left quote-icon"></i>
                <p className="testimonial-text">{t(d.text)}</p>
            </div>
            <div className="testimonial-footer">
              <h4 className="testimonial-name">{d.name}</h4>
              <p className="testimonial-username">{t(d.designation)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
